import React from "react";
import "./OrderComp.scss";
const OrderComp = (props) => {
  return (
    <>
      <div className="order">
        <div className="container">
          <div className="order_container">
            <div className="code_block">
              <span>#WU3746HGG12</span>
              <p>
                Aug {props.price}, 2023 <a href="#">. Delivered</a>
              </p>
            </div>
            <div className="order_block">
              <div className="title">
                <img src={props.img} alt="order-img"></img>
                <div className="title_name">
                  <h3>{props.name}</h3>
                  <p>
                    Natural | XL
                    <br></br>
                    Qty 1
                  </p>
                </div>
              </div>
              <div className=" price">
                <span>${props.price}</span>
                <a href="dhjuid">Leave review</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderComp;
